import ChipLink from './ChipLink';

export default ChipLink;
